import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/styles.scss';export default {
  "groupCreation": "_groupCreation_uv3gx_1",
  "main": "_main_uv3gx_5",
  "buttons": "_buttons_uv3gx_12"
};